import RandingStyle4 from "../../randing/RandingStyle4";
import RandingStyle5 from "../../randing/RandingStyle5";

function Randing026({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/026/24120301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/026/24120302.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_06.jpg`} // 스텝 변경되는 이미지
      benefitInfoPosition="top"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      apiUrl={apiUrl}
    />
  );
}

export default Randing026;
